import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import { CollapsibleCard, SimpleModal } from '@festina-life/ui/structure'
import cx from 'classnames'
import { useState } from 'react'

import { ChangelogMarkdownViewer } from './ChangelogMarkdownViewer'
import { useChangelogDiff } from './useChangelogDiff'

export const ChangelogDiffModal = () => {
  const { onRead, newParts, oldParts } = useChangelogDiff()
  const [isChangelogModalOpen, setIsChangelogModalOpen] = useState(
    !!newParts.length,
  )
  const translate = useTranslate()

  const handleMarkChangelogAsRead = () => {
    onRead()
    setIsChangelogModalOpen(false)
  }

  return (
    <SimpleModal
      isOpen={isChangelogModalOpen}
      title={translate('changelogDiffModal.title')}
      closeConfiguration={{ onClose: () => setIsChangelogModalOpen(false) }}
      acceptConfiguration={{
        label: translate('changelogDiff.modal.acceptButton'),
        onAccept: handleMarkChangelogAsRead,
      }}
      bodyOuterClassName="w-[90vw] h-[90vh] max-w-[90vw] max-h-[90vh]"
    >
      <div className="flex h-full flex-col gap-y-8">
        {!!newParts.length &&
          newParts.map((part, index) => (
            <div
              className={cx('rounded-md p-1', paperStyles({ isFaded: true }))}
              // oxlint-disable-next-line react/no-array-index-key
              key={index}
            >
              <ChangelogMarkdownViewer>{part}</ChangelogMarkdownViewer>
            </div>
          ))}
        {!!oldParts.length && (
          <CollapsibleCard
            title={translate('changelogDiff.oldChanges.title')}
            isInitialOpen={false}
          >
            {oldParts.map((part, index) => (
              <div
                className={cx('rounded-md p-1', paperStyles({ isFaded: true }))}
                // oxlint-disable-next-line react/no-array-index-key
                key={index}
              >
                <ChangelogMarkdownViewer>{part}</ChangelogMarkdownViewer>
              </div>
            ))}
          </CollapsibleCard>
        )}
      </div>
    </SimpleModal>
  )
}
